import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getErrorMessage } from '@shared/error';

export const useLoginFormError = (
	onError: (error: string) => void,
	defaultError: string = 'Unfortunately, something went wrong. Please try again or contact with us'
) => {
	const { t } = useTranslation('LoginPage');

	const setDefaultError = useCallback(() => {
		onError(t(defaultError));
	}, [onError, t, defaultError]);

	const setError = useCallback(
		(error: unknown) => {
			const message = getErrorMessage(error, defaultError);

			onError(t(message));
		},
		[onError, t, defaultError]
	);

	return {
		setError,
		setDefaultError
	};
};
